// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DayPicker__horizontal {
  margin-left: auto;
  margin-right: auto;
}

.CalendarDay__highlighted_calendar {
  background: #FF5959;
}

.CalendarDay__highlighted_calendar:hover {
  background: #Fa8F8F;
}
`, "",{"version":3,"sources":["webpack://./node_modules/@htmniseko/htm-ui/DatePicker/css/MultiDatePicker.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB","sourcesContent":[".DayPicker__horizontal {\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.CalendarDay__highlighted_calendar {\n  background: #FF5959;\n}\n\n.CalendarDay__highlighted_calendar:hover {\n  background: #Fa8F8F;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
